import styleAnswer from "./qustions.module.css";
import {ReturnTextAndImg} from "../../test/CheckImg";
import React from "react";

const styleTable = {str:{display:'flex'},element:{width:'90px',border:'1px solid black',overflowWrap: 'break-word'}}

export const userAnswer = (question)=>{
    if(!question){
        return null
    }
    if(question.type ===1 || question.type===2){
        const answer =[]  ;

        for (let key in question.answers) {
            if(question.answers[key]){
                answer.push(key)
            }
        }
        return <div>{answer.map((item,i)=><div key={i} className={styleAnswer.rightAnswer}>{i+1}) {ReturnTextAndImg(item)}</div>)}</div>
    }
    if(question.type===3 || question.type===4){
        return <div>{ReturnTextAndImg(question.answers.value)}</div>
    }
    if( question.type===5){
        const answer =[]
        for (let key in question.answers) {
            answer.push([ReturnTextAndImg(key),ReturnTextAndImg(question.answers[key])])
        }
        return answer.map((item,i)=><div key={i} className={styleAnswer.rightAnswer}>{item[0]} - {item[1]}</div>)
    }
    if( question.type===6){
        return question.answers.value.map((item,i)=><div key={i}>{i+1}) {item}</div>)
    }
    if(question.type === 7){
        return question.answers.value.map((item,i)=><div key={i}>{ReturnTextAndImg(item)}</div>)
    }
    if(question.type===8 ){
        const checkAnswer = question.answers.answer;
        const textAnswer = question.answers.text;
        return <div>
            <div>{checkAnswer.map((item,i)=><div key={i}>{ReturnTextAndImg(item)}</div>)}</div>
            <div>{textAnswer}</div>
        </div>
    }
    if(question.type===9){
        return <div>{question.answers.map((item,i)=><div key={i}>{i+1}) {item}</div>)}</div>
    }
    if(question.type===10){
        const answer = [...question.answers]
        answer.shift();
        const newAnswer=[];
        for(let i=0;i<answer.length;i++){
            newAnswer.push(answer[i].filter((item,count)=>count !==0))
        }
        return <div>{newAnswer.map((str,i)=>
            <div key={i} style={styleTable.str}>
                {str.map((item,count)=>
                    <div key={`${i} ${count}`} style={styleTable.element}>{!!item?'o':'x'}</div>
                )}
            </div>)}
        </div>
    }
    if(question.type===11){
        const checkAnswer = question.answers.answers;
        const textAnswer = question.answers.text;
        return <div>
            <div>{checkAnswer.map((item,i)=><div key={i}>{ReturnTextAndImg(item)}</div>)}</div>
            <div>{textAnswer}</div>
        </div>

    }
}